<main>
    <nav class="main-nav">
        <h2>
            <a (click)='index()'>{{title}}</a>
        </h2>
        <app-menu></app-menu>
    </nav>
    <router-outlet></router-outlet>
    <app-build-number></app-build-number>
</main>